import * as Yup from 'yup';

export interface LoginDto {
  username: string,
  password: string,
}

export const loginInit: LoginDto = { username: '', password: '' };


export interface TokenDto {
  userName: string,
  userId: string,
  authToken: string,
  validTo: string, //($date - time)
  refreshToken: string,
  fullName: string,
  roles: string[],
  expiresIn: number,
}

export const tokenInit: TokenDto = { userName: '', userId: '', authToken: '', validTo: '', refreshToken: '', fullName: '', roles: [], expiresIn: 0 };

export const loginValidationSchema = 
  Yup.object({
    username: Yup.string()
      .email('Enter a valid username')
      .required('Enter a username'),
    password: Yup.string()
      //.max(50, 'Must be 50 characters or less')
      .required('Enter a password'),
  })
